import { useEffect, useState } from 'react';

/* Vigia de versão.

   Problema real que isto resolve: o navegador pode ficar com arquivos antigos
   guardados e continuar mostrando a aparência velha mesmo depois de uma publicação.
   Aqui o app compara a sua própria compilação com a que está no servidor e, se
   estiver atrasado, oferece a atualização — e recarrega ignorando o cache. */

const INTERVALO = 4 * 60_000;

export function UpdateWatcher() {
  const [novaVersao, setNovaVersao] = useState<string | null>(null);

  useEffect(() => {
    let vivo = true;

    const conferir = async () => {
      try {
        const r = await fetch(`/build.json?t=${Date.now()}`, { cache: 'no-store' });
        if (!r.ok) return;
        const { build } = (await r.json()) as { build?: string };
        if (vivo && build && build !== __BUILD__) setNovaVersao(build);
      } catch {
        /* Sem rede: tenta de novo mais tarde. */
      }
    };

    conferir();
    const id = window.setInterval(conferir, INTERVALO);
    window.addEventListener('focus', conferir);
    return () => { vivo = false; window.clearInterval(id); window.removeEventListener('focus', conferir); };
  }, []);

  if (!novaVersao) return null;

  const atualizar = () => {
    /* Limpa o que o navegador guardou deste site antes de recarregar. */
    if ('caches' in window) {
      caches.keys().then((ks) => Promise.all(ks.map((k) => caches.delete(k)))).finally(() => location.reload());
    } else {
      location.reload();
    }
  };

  return (
    <div className="update-bar" role="status">
      <span>Existe uma versão mais nova do Jarvis ({novaVersao} UTC). Esta aba está com uma versão antiga.</span>
      <button type="button" className="btn btn-sm btn-primary" onClick={atualizar}>Atualizar agora</button>
    </div>
  );
}
